import moment from "moment";

const MINUTE_IN_MS = 60000;
const HOUR_IN_MS = MINUTE_IN_MS * 60;
const DAY_IN_MS = HOUR_IN_MS * 24;
const WEEK_IN_MS = DAY_IN_MS * 7;
const YEAR_IN_MS = DAY_IN_MS * 365;

const fromNowChathead = (date) => {
  const mDate = moment(date);
  const diffMilliseconds = Math.abs(moment().diff(mDate));

  if (diffMilliseconds < MINUTE_IN_MS) {
    return "now";
  }

  if (diffMilliseconds < HOUR_IN_MS) {
    const minutes = Math.round(diffMilliseconds / MINUTE_IN_MS);
    return `${minutes}m`;
  }

  if (diffMilliseconds < DAY_IN_MS) {
    const hours = Math.round(diffMilliseconds / HOUR_IN_MS);
    return `${hours}h`;
  }

  if (diffMilliseconds < WEEK_IN_MS) {
    const days = Math.round(diffMilliseconds / DAY_IN_MS);
    return `${days}d`;
  }

  if (diffMilliseconds < YEAR_IN_MS) {
    const weeks = Math.round(diffMilliseconds / WEEK_IN_MS);
    return `${weeks}w`;
  }

  const years = Math.round(diffMilliseconds / YEAR_IN_MS);
  return `${years}y`;
};

export { fromNowChathead };
